import DeviceData from '@/apps/device/components/events/DeviceData.vue';
import FirmwareVersion from '@/apps/device/components/events/FirmwareVersion.vue';
import UpdateRequest from '@/apps/device/components/events/UpdateRequest.vue';

export const deviceEventTypes: { [eventName: string]: any } = {
  'update-request': UpdateRequest,
  'firmware-version': FirmwareVersion,
  'device-data': DeviceData,
};
